// Shared Zod primitives used by other schemas.
import { z } from 'zod';

/** URL or the literal "#" (used for placeholder links). */
export const URLOrHashSchema = z.union([z.string().url(), z.literal('#')]);

/** Icon name string (lucide-react name). */
export const IconNameSchema = z.string().min(1);

/** [iconName, label] tuple. */
export const IconLabelTupleSchema = z.tuple([IconNameSchema, z.string()]);

/** Optional thumbnail — either a URL string or a structured object. */
export const ThumbnailSchema = z
  .union([
    z.string().url(),
    z.object({
      src: z.string(),
      alt: z.string().default(''),
      width: z.number().int().positive().optional(),
      height: z.number().int().positive().optional(),
    }),
  ])
  .optional();
